import LegalPage from "@/components/LegalPage";

const sections = [
  {
    heading: "Acceptance of Terms",
    body: "By accessing or using the KSDevArc website, you agree to be bound by these Terms of Use. If you do not agree with these terms, please discontinue use of the website.",
  },
  {
    heading: "Website Purpose",
    body: "This website is provided for informational purposes regarding KSDevArc's Website development, Web & Mobile application development, Light weight SaaS, AI and AI technology, Digital Transformation, architectural design, 3D visualization, consultancy, and related services.",
  },
  {
    heading: "Intellectual Property",
    body: "All content on this website, including renderings, drawings, designs, graphics, images, text, logos, project materials, and other content, is owned by KSDevArc or its licensors and is protected by applicable intellectual property laws. No content may be copied, reproduced, distributed, modified, or used without prior written permission.",
  },
  {
    heading: "Portfolio and Project Materials",
    body: "Architectural concepts, renderings, visualizations, drawings, and project imagery displayed on this website are intended for presentation purposes. Actual completed works may differ from conceptual designs and visual representations.",
  },
  {
    heading: "No Professional Relationship",
    body: "Use of this website, submission of enquiries, or receipt of information from KSDevArc does not create a consultant-client relationship, contractual relationship, or professional engagement unless a separate written agreement has been executed.",
  },
  {
    heading: "Quotations and Estimates",
    body: "Any quotations, proposals, budgets, timelines, or project estimates provided through the website or subsequent communications are subject to review and may change based on project scope, specifications, and requirements.",
  },
  {
    heading: "User Conduct",
    body: "You agree not to misuse the website, attempt unauthorized access, distribute malicious software, interfere with website operations, or engage in unlawful activities through the website.",
  },
  {
    heading: "Third-Party Links",
    body: "The website may contain links to external websites for convenience. KSDevArc is not responsible for the content, security, availability, or privacy practices of third-party websites.",
  },
  {
    heading: "Disclaimer",
    body: "Information provided on this website is supplied on an 'as is' and 'as available' basis. While reasonable efforts are made to ensure accuracy, KSDevArc makes no warranties regarding completeness, reliability, or suitability of the information presented.",
  },
  {
    heading: "Limitation of Liability",
    body: "To the fullest extent permitted by law, KSDevArc shall not be liable for any direct, indirect, incidental, consequential, or special damages arising from the use of, or inability to use, this website.",
  },
  {
    heading: "Changes to Terms",
    body: "KSDevArc reserves the right to modify these Terms of Use at any time. Updated versions will be published on the website and become effective upon posting.",
  },
  {
    heading: "Governing Law",
    body: "These Terms of Use shall be governed by and construed in accordance with the laws of Singapore. Any disputes shall be subject to the exclusive jurisdiction of the Singapore courts.",
  },
  {
    heading: "Contact Information",
    body: "KSDevArc\nUEN: 53526011C\nEmail: admin@ksdevarc.com\nWebsite: www.ksdevarc.com",
  },
];

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Use"
      lastUpdated="18 June 2026"
      sections={sections}
      seoDescription="The legal terms governing your use of the KSDevArc website and services."
    />
  );
}
